// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fendBFsTjdQ6YQSe {
	font: var(--lok-typography-body-small-strong);
	font-family: var(--lok-font-family-inter);
}
`, "",{"version":3,"sources":["webpack://./packages/rag/src/components/BaseProfileModal/components/BaseProfileOverviewStep/BaseProfileOverviewStep.module.css"],"names":[],"mappings":"AAAA;CACC,6CAA6C;CAC7C,yCAAyC;AAC1C","sourcesContent":[".stepsContainerHeading {\n\tfont: var(--lok-typography-body-small-strong);\n\tfont-family: var(--lok-font-family-inter);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stepsContainerHeading": `fendBFsTjdQ6YQSe`
};
export default ___CSS_LOADER_EXPORT___;
